class Platform {


	initRefreshCache() {
		document.getElementById('refresh-cache').addEventListener('click', (event) => {
			fetch(NSContext.site.restUrl + 'admin/transients/clean',
				{
					method: 'DELETE',
					headers: {'X-WP-Nonce': NSContext.nonce}
				})
				.then((response) => {
					return response.json();
				})
				.then((payload) => {
					if (payload.data.status === 400) {
						console.warn(payload.code + ': ' + payload.message);
					} else {
						console.log(payload.records + ' transients cleaned');
						location.reload();
					}
				})
				.catch((error) => {
					console.log(error);
				});
		});
	}

  getHomeUrl() {
    return NSContext.site.homeUrl;
  }


  getSiteUrl() {
    return NSContext.site.siteUrl;
  }


  getAjaxUrl() {
    return NSContext.site.ajaxUrl;
  }

  getRestUrl() {
    return NSContext.site.restUrl;
  }

  getThemeUrl(url) {
    if (url !== null) {
      return NSContext.theme.url + '/' + url;
    }
    return NSContext.theme.url;
  }


}

export default new Platform();
